import { Typography } from '@mui/material';
import { getNoResultsSx } from '../dropdownConsts';
import { useTranslation } from 'react-i18next';

type SelectNoResultsProps = {
  message?: string;
};

export const SelectNoResults = ({ message }: SelectNoResultsProps) => {
  const { t } = useTranslation();
  const defaultMessage = t('blox.general.no_results_found');

  return <Typography sx={getNoResultsSx}>{message || defaultMessage}</Typography>;
};

SelectNoResults.displayName = 'SelectNoResults';
